import React, { useEffect, memo } from "react";
import ReactMapboxGL from "react-mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const accessToken = process.env.REACT_APP_MAPBOX_API_KEY;

const styles = {
  position: "relative",
  height: "100%",
  width: "100%",
};

const Map = ReactMapboxGL({
  accessToken,
});

const Mapbox = ({ children, handleOnLoad, coordinates, zoom }) => {
  const mapStyle = {
    style: "mapbox://styles/mapbox/streets-v11",
  };

  useEffect(() => {
    handleOnLoad && handleOnLoad();
  }, [handleOnLoad]);

  return (
    <Map center={coordinates} {...mapStyle} containerStyle={styles} zoom={zoom}>
      {children}
    </Map>
  );
};

export default memo(Mapbox);
